/** Per-user, per-day dismissal of the optional Microsoft connection prompt (browser-local). */
const DISMISS_KEY_PREFIX = 'helios.m365ConnectPrompt.dismissedOn';

/** Local calendar day, so a dismissed prompt returns the next working day. */
export function microsoftPromptLocalDay(now = new Date()): string {
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return `${now.getFullYear()}-${month}-${day}`;
}

export function microsoftPromptDismissKey(tenantId?: string | null, userId?: string | null) {
  return `${DISMISS_KEY_PREFIX}:${tenantId ?? 'tenant'}:${userId ?? 'user'}`;
}

export function readMicrosoftPromptDismissed(key: string): boolean {
  try {
    return window.localStorage.getItem(key) === microsoftPromptLocalDay();
  } catch {
    return false;
  }
}

export function writeMicrosoftPromptDismissed(key: string) {
  try {
    window.localStorage.setItem(key, microsoftPromptLocalDay());
  } catch {
    // Storage can be unavailable (private mode); dismissal still holds for this render tree until the local day changes.
  }
}
